import React from 'react';

function Spinner({ label, size = 20 }) {
    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '8px 0',
            fontSize: '14px',
            color: '#000000'
        }}>
            <div
                style={{
                    width: `${size}px`,
                    height: `${size}px`,
                    border: '2px solid #e0e0e0',
                    borderTopColor: '#4a90e2',
                    borderRadius: '50%',
                    animation: 'spinner-rotate 0.8s linear infinite'
                }}
            />
            {label && <span>{label}</span>}
            <style>{`
                @keyframes spinner-rotate {
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
}

export default Spinner;